import { Button, Typography } from '@mui/material';
import './Orientacoes.scss';

import { useAtom } from 'jotai';
import { FC, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { accessToken } from '../../atoms/atom';

const Orientacoes: FC = () => {
	const { id } = useParams<{ id: string }>();
	const [accessTokenAtom] = useAtom(accessToken);
	const isMounted = useRef(true);
	const navigate = useNavigate();

	const next = () => {
		navigate(`/${id}/pergunta`);
	}

	useEffect(() => {
		const token = accessTokenAtom || localStorage.getItem("access-token");
		if (!token && isMounted.current) {
			navigate(`/${id}/login`);
		}
	}, [accessTokenAtom]);

	return (
		<div className="orientations">
			<h2>Percepção individual dos riscos psicossociais</h2>
			<Typography variant='subtitle2' align='justify'>
				Por favor, responda a cada pergunta com sinceridade e atenção, expressando sua real
				percepção sobre os riscos psicossociais que você enfrenta no dia a dia. Sua
				honestidade e sinceridade nas respostas farão toda a diferença!
			</Typography>
			<h2>Orientações para responder:</h2>
			<Typography variant='subtitle2' align='justify'>
				Das seguintes afirmações indique a opção que mais se adéqua à sua resposta de acordo com as seguintes alternativas:
			</Typography>
			<p style={{textAlign:"left", width:"100%"}}>1 - <b>Nunca</b>: A situação descrita nunca acontece.</p>
			<p style={{textAlign:"left", width:"100%"}}>2 - <b>Raramente</b>: A situação descrita acontece muito raramente.</p>
			<p style={{textAlign:"left", width:"100%"}}>3 - <b>Às vezes</b>: A situação descrita acontece ocasionalmente.</p>
			<p style={{textAlign:"left", width:"100%"}}>4 - <b>Frequentemente</b>: A situação descrita acontece com frequência.</p>
			<p style={{textAlign:"left", width:"100%"}}>5 - <b>Sempre</b>: A situação descrita acontece sempre.</p>
			<Typography variant='subtitle2' align='justify'>
				Por favor, sua sinceridade é crucial. Respostas sem coerência podem distorcer os
				resultados edificultar aidentificação das reais necessidades dos colaboradores.
			</Typography>
			<h2>Importante</h2>
			<Typography variant='subtitle2' align='justify'>
				Pedimos que você responda às perguntas com sinceridade e reflexão, considerando que as situações descritas
				podem ser comuns ao seu segmento e função. Ao pontuar suas respostas, avalie, com critério, os fatores que
				realmente possam representar um risco à sua saúde mental no trabalho e que, comprovadamente, estão ocorrendo
				na empresa.
			</Typography>
			<Button onClick={() => next()} variant='contained' color='primary' size='large'>
				Continuar
			</Button>
		</div>
	)
}

export default Orientacoes;